import {useState} from "react";
import {useTypedSelector} from "src/store";
import {selectSelectedRegion} from "src/store/slices/userLocation";
import {RegionSlug} from "src/store/types";

import {useEffectAsync} from "../components/_common/Carbon";
import {PricingTierItem, usePricingData} from "../utils/fetchPricingData";
import {getPricingTierByRegionSlug} from "../utils/getPricingTierBySlug";

export const usePricesByRegion = (regionSlug?: string): PricingTierItem[] => {
  const [prices, setPrices] = useState<PricingTierItem[]>([]);
  const regionPricing = usePricingData();
  const selectedRegion = useTypedSelector(selectSelectedRegion);
  const slugToCheck = regionSlug || selectedRegion;

  useEffectAsync(async () => {
    if (!regionPricing) return;
    const priceTier = getPricingTierByRegionSlug(slugToCheck as RegionSlug);
    setPrices(regionPricing[priceTier]);
  }, [selectedRegion, regionSlug, regionPricing]);

  return prices;
};
